import { toggleVariants } from '@/components/ui/Toggle/Toggle';
import { cn } from '@/utils/index';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const ToggleGroupContext = React.createContext<VariantProps<typeof toggleVariants>>({
  size: 'M',
  variant: 'default',
});

const ToggleGroup = ({
  className,
  size = 'M',
  variant = 'default',
  children,
  ...props
}: React.ComponentPropsWithRef<typeof ToggleGroupPrimitive.Root> & VariantProps<typeof toggleVariants>) => {
  const contextValue = React.useMemo(() => ({ size, variant }), [size, variant]);

  return (
    <ToggleGroupPrimitive.Root className={cn('flex items-center justify-center gap-3', className)} {...props}>
      <ToggleGroupContext value={contextValue}>{children}</ToggleGroupContext>
    </ToggleGroupPrimitive.Root>
  );
};

const ToggleGroupItem = ({
  className,
  children,
  size,
  ...props
}: React.ComponentPropsWithRef<typeof ToggleGroupPrimitive.Item> & VariantProps<typeof toggleVariants>) => {
  const context = React.use(ToggleGroupContext);

  return (
    <ToggleGroupPrimitive.Item
      className={cn(
        toggleVariants({
          size: context?.size ?? size,
          variant: context?.variant,
        }),
        className,
      )}
      {...props}
    >
      {children}
    </ToggleGroupPrimitive.Item>
  );
};

export { ToggleGroup, ToggleGroupItem };
